<template>
  <div class="account-page py-4 mt-4">
    <div class="flex items-center gap-3 flex-wrap">
      <Spin :spinning="employersQuery && employersQuery.isLoading">
        <Select class="text-center min-w-[300px]" :value="employer_id" @change="handleSelectBusiness" allowClear
          placeholder="Select business">
          <select-option v-for="buss in employersData" :key="buss._id" :value="buss._id">{{ buss.community_name }} , {{
            buss.name }}</select-option>
        </Select>
      </Spin>
    </div>
    <MonthlyStatsEmployer />
    <CommuteStats />
    <EmployersQuery />
  </div>
</template>
<script>
import { Select, SelectOption, Spin } from 'ant-design-vue';
import { ADMIN_STATS } from '@/store/types';
import EmployersQuery from '@/services/queries/admin/employers/EmployersQuery.vue';
import CommuteStats from './CommuteStats.vue';
import MonthlyStatsEmployer from './MonthlyStatsEmployer.vue';

export default {
  components: {
    MonthlyStatsEmployer,
    CommuteStats,
    Spin,
    EmployersQuery,
    Select,
    SelectOption,
  },
  data() {
    return {
      employer_id: null,
    };
  },
  created() { },
  computed: {
    employersQuery() {
      return this.$store.state.adminEmployers.employersQuery;
    },
    employersData() {
      return this.$store.getters.employersData?.data || [];
    },

  },
  methods: {
    handleSelectBusiness(val) {
      this.employer_id = val;
      this.$store.commit(ADMIN_STATS.SET_EMPLOYER_FILTER_ID, val);
    },
  },
};
</script>
